var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "95px",
    viewBox: "0 0 95 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5,0 C21.301,0 0,21.301 0,47.5 C0,73.699 21.301,95 47.5,95 C73.699,95 95,73.699 95,47.5 C95,21.301 73.699,0 47.5,0 Z M42.1992,23.801 C42.1992,20.9026 44.5976,18.5002 47.5,18.5002 C50.3984,18.5002 52.8008,20.8986 52.8008,23.801 L52.8008,50.301 C52.8008,53.1994 50.4024,55.6018 47.5,55.6018 C44.6016,55.6018 42.1992,53.2034 42.1992,50.301 L42.1992,23.801 Z M47.5,76.199 C43.6992,76.199 40.6016,73.0974 40.6016,69.3006 C40.6016,65.4998 43.7032,62.4022 47.5,62.4022 C51.3008,62.4022 54.3984,65.5038 54.3984,69.3006 C54.3984,73.1014 51.3007,76.199 47.5,76.199 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default ForwardRef;